// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_2k-1";
export var movingGradient = "_2k-4";
export var movingGradientBlock = "_2k-2";
export var skeleton = "_2k-0";
export var skeletonText = "_2k-3";